import createDuck, { createAction, createThunk } from "./../utils/actions";
import axios from "../net/axios";
import config from "./../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  "NAME": (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("LOGIN_STANDARD", newActions, newReducers);

const loginStandardThunk = (data) => {

  const url = `${baseUrl}/v2/login?origen=admin`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckSocial = createDuck("LOGIN_SOCIAL", newActions, newReducers);

const loginSocialThunk = (data) => {

  const url = `${baseUrl}/v2/login`;
  return createThunk(axios, "post", duckSocial.actions, url, data);
};


const duckTerminos = createDuck("ACEPTAR_TERMINOS", newActions, newReducers);

const updateTerminosAceptadosThunk = (data) => {

  const url = `${baseUrl}/updateTerminosAceptados`;
  return createThunk(axios, "post", duckTerminos.actions, url, data);
};

export default {
  duck,
  loginStandardThunk,
  duckSocial,
  loginSocialThunk,
  duckTerminos,
  updateTerminosAceptadosThunk,
};
